import routerOptions0 from "/root/.jenkins/workspace/tduck-cms-front/node_modules/.pnpm/nuxt@3.7.3_@opentelemetry+api@1.8.0_eslint@8.57.0_sass@1.77.2_typescript@5.4.5_vue-tsc@1.8.27/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}